import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";

var token = localStorage.getItem("x-access-token");
export const fetchActivite = createAsyncThunk("activite/fetchActivite", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "activite/allActivite", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },

  });
  const activite = await response.json();
  return activite;
});
export const getActiveActivite = createAsyncThunk("activite/getActiveActivite", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "activite/getActive", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },

  });
  const activite = await response.json();
  return activite;
});
export const getDetailsactivite = createAsyncThunk("activite/getDetailsactivite", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "activite/getDetailsactivite", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body: JSON.stringify(action)

  });
  const activite = await response.json();
  return activite;
});
export const getLastDetail = createAsyncThunk("activite/getLastDetail", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "activite/getLastDetail", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body: JSON.stringify(action)

  });
  const activite = await response.json();
  return activite;
});

export const activiteGetById = createAsyncThunk("activite/activiteGetById", async (id1) => {
  const  id  = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "activite/getActivite", {
    method: 'POST',
    headers: {
      'id':id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
  
  });
  const activite = await response.json();
  return activite;
});
export const activiteChangeEtat = createAsyncThunk("activite/changerEtat", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "activite/changeEtat/"+id, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
  });
  const activite = await response.status;
  return activite;
});
export const activiteAdded = createAsyncThunk("activite/addActivite", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "activite/addActivite", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body: JSON.stringify(action)
  });
  const activite = await response.json();
  return activite;
});
const activiteReduce = createSlice({
  name: "activite",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    /* activiteAdded(state, action) {
      fetch(Configuration.BACK_BASEURL + "activite/addActivite", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
        body: JSON.stringify(action.payload)
      });
    }, */
    addcsvactivite(state, action) {
      fetch(Configuration.BACK_BASEURL + "activite/addcsvactivite", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
        body: JSON.stringify(action.payload)
      });
    },
    deleteDetailActivite(state, action) {
      const id  = action.payload;
      fetch(Configuration.BACK_BASEURL + "activite/deleteDetail/"+id, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
      });
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivite.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchActivite.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchActivite.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(activiteGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(activiteGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(activiteGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },
  
});

export const { addcsvactivite,deleteDetailActivite } = activiteReduce.actions;

export default activiteReduce.reducer;
